/**
 * MODULE: domain/pages/frontend/hooks/usePipelineSnapshot.ts
 * PURPOSE: TanStack Query hook for live CRM pipeline snapshot block data
 */

import { useQuery } from '@tanstack/react-query';
import { crmKpis, crmList, type CrmKpisResponse } from '@shared/lib/frontend/api/crmApi';
import {
  computePipelineStageCounts,
  type PipelineStageCount,
} from '../utils/pagePipelineSnapshotUtils';

export const PIPELINE_SNAPSHOT_QUERY_KEY = ['pages', 'pipeline-snapshot'] as const;

export type PipelineSnapshotData = {
  kpis: CrmKpisResponse;
  stageCounts: PipelineStageCount[];
};

export function usePipelineSnapshot(options?: { enabled?: boolean }) {
  const enabled = options?.enabled !== false;
  return useQuery({
    queryKey: PIPELINE_SNAPSHOT_QUERY_KEY,
    queryFn: async (): Promise<PipelineSnapshotData> => {
      const [kpis, dealsRes] = await Promise.all([
        crmKpis(),
        crmList<{ id: string; stage?: string | null }>('deals', { limit: 500 }),
      ]);
      return {
        kpis,
        stageCounts: computePipelineStageCounts(dealsRes.items ?? []),
      };
    },
    enabled,
    staleTime: 60_000,
  });
}
